import {
	DocumentsOfObjectDataGridContextMenuProps
} from "src/components/views/documents/objectDocuments/DocumentsOfObjectDataGridContextMenu.tsx";
import { AsyncButtonContextMenuItem } from "src/components/common/contextMenu/AsyncButtonContextMenuItem.tsx";
import { useOpenLegacyView } from "src/components/views/legacy/hooks.ts";
import { faFile } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";

export const LehtoDocumentsOfObjectDataGridContextMenuComponents = (
	{
		row
	}: DocumentsOfObjectDataGridContextMenuProps) => {

	const openLegacyView = useOpenLegacyView();

	return row.primaryFileExtension?.toLowerCase() !== "bltetl" &&
		<AsyncButtonContextMenuItem
			label={i18n.t("create_asc_files")}
			icon={faFile}
			onClick={async () => {
				openLegacyView(LEHTO_BTL_PROJECT_TREE_VIEW_REF, {
					documentId: row.documentId
				});
			}}
		/>;
};

const LEHTO_BTL_PROJECT_TREE_VIEW_REF = "69A04CD5DF570322";